import { get, startCase, uniqueId } from "lodash";
import {
  ILayoutSettings,
  PageSectionCategory,
} from "@/Apps/Pages/Sections/WebLayouts/types";
import { ComponentTypes } from "@/Apps/Pages/Editor/types";
import { BenefitLayouts } from "../types";

import { combineData, lorem } from "../../utils";
import { style } from "./style";
import { IconTypes } from "@/Apps/Pages/WebComponents/v2/Icon";
import { default as defaultData } from "./data.json";
import {
  getImagePlaceholder,
  ImagePlaceholderTypes,
  getVideoPlaceholder,
  VideoPlaceholderTypes,
} from "../../Placeholders";
import theme from "../../theme";
const content = combineData(defaultData);

const settings: ILayoutSettings = {
  label: BenefitLayouts.TWENTY,
  layout: BenefitLayouts.TWENTY,
  previewImage:
    "https://sandcastleassets.s3.amazonaws.com/blocks/benefits/Benefit20.png",
  loadFromExt: true,
  loadFromExtSettings: {
    pageId: "ckkx8c94s23wd0780cdzpdmmv",
    itemId: "yp54iisnreb",
  },
  default: {
    label: PageSectionCategory.BENEFIT,
    type: ComponentTypes.SECTION,
    bodyOnly: true,
    canHaveChildren: true,
    properties: {
      ...style.SECTION,
      ...style.SECTION_INNER,
    },
    children: [
      {
        type: ComponentTypes.COLUMNS,
        canHaveChildren: false,
        properties: {
          width: "100%",
        },
        children: [
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((6 * 100) / 12),
            properties: { height: "100%", padding: 0, minHeight: 20 },
            children: [
              {
                type: ComponentTypes.CONTAINER,
                canHaveChildren: true,
                properties: {
                  mobile: {
                    desktop: {
                      padding: 50,
                    },
                    smartphone: {
                      padding: 10,
                    },
                  },
                },
                children: [
                  {
                    type: ComponentTypes.LISTITEM,
                    canHaveChildren: false,
                    properties: { ...style.LI, color: "black" },
                    html: `One-on-one`,
                  },
                  {
                    type: ComponentTypes.LISTITEM,
                    canHaveChildren: false,
                    properties: style.LI,
                    html: `Try it Free`,
                  },
                  {
                    type: ComponentTypes.LISTITEM,
                    canHaveChildren: false,
                    properties: style.LI,
                    html: `Fanatical Support`,
                  },
                  {
                    type: ComponentTypes.LISTITEM,
                    canHaveChildren: false,
                    properties: style.LI,
                    html: `Rapid response`,
                  },
                ],
              },
            ],
          },
          {
            type: ComponentTypes.COLUMN,
            canHaveChildren: true,
            preventDelete: true,
            md: parseInt((6 * 100) / 12),
            properties: { height: "100%", padding: 0, minHeight: 20 },
            children: [
              {
                type: ComponentTypes.CONTAINER,
                canHaveChildren: true,
                properties: {
                  mobile: {
                    desktop: {
                      padding: 90,
                    },
                    smartphone: {
                      padding: 10,
                    },
                  },
                },
                children: [
                  {
                    type: ComponentTypes.ICON,
                    canHaveChildren: false,
                    properties: style.ICON,
                    iconType: IconTypes.Settings,
                  },
                  {
                    type: ComponentTypes.HEADLINE,
                    canHaveChildren: false,
                    properties: {
                      ...style.HEADLINE,
                      ...get(content, "main_headline.style", {}),
                    },
                    html: get(content, "main_headline.html", "..."),
                  },
                  {
                    type: ComponentTypes.TEXT,
                    canHaveChildren: false,
                    properties: {
                      ...style.TEXT,
                      ...get(content, "sub_headline.style", {}),
                    },
                    html: get(content, "sub_headline.html", "..."),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default settings;
